import { CardActions as MuiCardActions, withStyles } from '@material-ui/core';

export const CardActions = withStyles({
  root: { justifyContent: 'space-between', minHeight: '42px' },
})(MuiCardActions);
